<template>
  <tg-layout>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      cell-class-name="clickable"
      showPagination
      :zebra="false"
      @row-click="handleRowClick"
    >
      <template slot="expand" slot-scope="scope">
        <el-row type="flex" justify="start" align="middle">
          <p>{{scope.row['desc']}}</p>
        </el-row>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";

import apis from "@/apis";

const api = apis.notice;

export default {
  components: {
    TgLayout,
    TgTable,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
    };
  },
  created() {
    this.$store.dispatch('app/fetch');
    api.getColumns().then((response) => {
      this.columns = response.data;
      this.$refs.table.init();
    });
  },
  methods: {
    handleRowClick(row) {
      this.$refs.table.$refs.ElTable.toggleRowExpansion(row);
    },
  },
};
</script>